<!-- Start Locations Banner Section -->
<section class="ecb-web-location-banner-section">
  <div class="ecb-web-location-banner-overlay"></div>

  <div class="container ecb-web-location-banner-container hero-inner">
    <div class="row align-items-center">

      <!-- Start Locations Banner Content Section -->
      <div class="col-12 col-lg-6">
        <div class="ecb-web-location-banner-content">

          <!-- Display the workplace health and safety category label. -->
          <span class="pill">Corporate Training Services</span>
          <!-- Display the main HSR Training heading. -->

          <h1>Corporate Training &amp; Training Request Forms</h1>

          <div class="ecb-web-voc-title-line"></div>

          <p>
            Book training for your organisation online or manage a Verification of
            Competency request from one convenient place.
          </p>

        </div>
      </div>
      <!-- End Locations Banner Content Section -->

    </div>
  </div>
</section>
<!-- End Locations Banner Section -->

<section class="ecb-corporate-page">

  <div class="ecb-corporate-main">
    <div class="container">
      <div class="ecb-corporate-switcher-wrap">
        <div class="ecb-corporate-switcher" role="tablist" aria-label="Corporate options">
          <button type="button" class="ecb-corporate-switch-button" [class.active]="selectedSection === 'BOOKING'"
            [attr.aria-selected]="selectedSection === 'BOOKING'" role="tab" (click)="selectSection('BOOKING')">
            <span class="ecb-corporate-switch-icon">
              <i class="bi bi-building-check"></i>
            </span>
            <span class="ecb-corporate-switch-copy">
              <strong>Corporate Online Booking</strong>
              <small>Complete the corporate training booking form online</small>
            </span>
            <!-- <i class="bi bi-chevron-right ecb-corporate-switch-arrow"></i> -->
          </button>

          <button type="button" class="ecb-corporate-switch-button" [class.active]="selectedSection === 'VOC'"
            [attr.aria-selected]="selectedSection === 'VOC'" role="tab" (click)="selectSection('VOC')">
            <span class="ecb-corporate-switch-icon">
              <i class="bi bi-file-earmark-check"></i>
            </span>
            <span class="ecb-corporate-switch-copy">
              <strong>Training Request Forms (TRF)</strong>
              <small>Download or upload a completed TRF</small>
            </span>
            <!-- <i class="bi bi-chevron-right ecb-corporate-switch-arrow"></i> -->
          </button>
        </div>
      </div>

      <section *ngIf="selectedSection === 'BOOKING'" class="ecb-corporate-panel ecb-corporate-booking-panel">
        <div class="ecb-corporate-panel-heading">
          <div class="ecb-corporate-panel-heading-icon">
            <i class="bi bi-buildings"></i>
          </div>
          <div>
            <span>Booking</span>
            <h2>Corporate Online Form</h2>
            <p>
              Complete the corporate booking form below and our team will process
              your training request.
            </p>
          </div>
        </div>

        <div class="ecb-corporate-form-host">
          <app-x-course-multi-form></app-x-course-multi-form>
        </div>
      </section>

      <section *ngIf="selectedSection === 'VOC'" class="ecb-corporate-panel ecb-corporate-voc-panel">
        <div class="ecb-corporate-panel-heading">
          <div class="ecb-corporate-panel-heading-icon">
            <i class="bi bi-patch-check"></i>
          </div>
          <div>
            <span>TRF</span>
            <h2>Training Request Forms</h2>
            <p>
              Download the request form, complete it, then return here to securely
              upload the completed PDF.
            </p>
          </div>
        </div>

        <div class="ecb-corporate-voc-grid">
          <article class="ecb-corporate-voc-card ecb-corporate-voc-download-card">
            <div class="ecb-corporate-voc-card-number">01</div>
            <div class="ecb-corporate-voc-card-icon">
              <i class="bi bi-file-earmark-pdf"></i>
            </div>
            <span class="ecb-corporate-voc-label">Step One</span>
            <h3>Download TRF</h3>
            <p>
              Download the official Training Request Form and complete all required
              details before submitting it back to ECB Training.
            </p>
            <a href="/assets/documents/voc-request-form.pdf" download class="btn ecb-corporate-voc-primary-button">
              <span>Download Training Request Form</span>
              <i class="bi bi-download"></i>
            </a>
          </article>

          <article class="ecb-corporate-voc-card ecb-corporate-voc-upload-card">
            <div class="ecb-corporate-voc-card-number">02</div>
            <div class="ecb-corporate-voc-card-icon">
              <i class="bi bi-cloud-arrow-up"></i>
            </div>
            <span class="ecb-corporate-voc-label">Step Two</span>
            <h3>Upload Completed Training Request Form</h3>
            <p>
              Upload your completed PDF and provide your email address so our team
              can contact you regarding your assessment request.
            </p>

            <div class="ecb-corporate-upload-layout">
              <div class="ecb-corporate-upload-file-column">
                <label for="corporateVocFormFile" class="ecb-corporate-file-drop" *ngIf="!formUrl">
                  <i class="bi bi-file-earmark-arrow-up"></i>
                  <strong>{{ isVocFileUploading ? 'Uploading PDF...' : 'Choose completed TRF' }}</strong>
                  <span>PDF only, maximum file size 10 MB</span>
                  <span class="btn ecb-corporate-file-button">
                    {{ isVocFileUploading ? 'Uploading...' : 'Choose File' }}
                  </span>
                  <input #vocFormFileInput id="corporateVocFormFile" type="file" accept="application/pdf" hidden
                    [disabled]="isVocFileUploading" (change)="onVocFileSelected($event)">
                </label>

                <div class="ecb-corporate-upload-progress" *ngIf="isVocFileUploading">
                  <i class="bi bi-arrow-repeat ecb-corporate-spin"></i>
                  <span>Uploading PDF...</span>
                </div>

                <div class="ecb-corporate-uploaded-file" *ngIf="formUrl && !isVocFileUploading">
                  <div class="ecb-corporate-uploaded-file-info">
                    <i class="bi bi-file-earmark-pdf-fill"></i>
                    <div>
                      <strong>{{ selectedVocFileName || 'Training Request Form.pdf' }}</strong>
                      <span>PDF uploaded successfully</span>
                    </div>
                  </div>
                  <div class="ecb-corporate-uploaded-file-actions">
                    <a [href]="formUrl" target="_blank" rel="noopener noreferrer" class="btn ecb-corporate-file-action">
                      <i class="bi bi-eye"></i>
                      View
                    </a>
                    <button type="button" class="btn ecb-corporate-file-action ecb-corporate-file-remove"
                      (click)="removeVocFile()">
                      <i class="bi bi-trash"></i>
                      Remove
                    </button>
                  </div>
                </div>

                <p class="ecb-corporate-error-text" *ngIf="vocFileErrorMessage">
                  <i class="bi bi-exclamation-circle"></i>
                  {{ vocFileErrorMessage }}
                </p>
              </div>

              <form class="ecb-corporate-upload-form" (ngSubmit)="uploadVocForm()">
                <label for="corporateVocEmailAddress" class="form-label">
                  Your Email Address <span>*</span>
                </label>
                <input id="corporateVocEmailAddress" type="email" name="corporateVocEmailAddress" class="form-control"
                  placeholder="name@example.com" [(ngModel)]="vocEmailAddress" required>

                <div *ngIf="successMessage" class="alert alert-success py-2 mt-3 mb-0" role="alert">
                  {{ successMessage }}
                </div>

                <div *ngIf="errorMessage" class="alert alert-danger py-2 mt-3 mb-0" role="alert">
                  {{ errorMessage }}
                </div>

                <button type="submit" class="btn ecb-corporate-voc-primary-button ecb-corporate-submit-button"
                  [disabled]="isUploading || isVocFileUploading">
                  <span>{{ isUploading ? 'Uploading...' : 'Upload Completed Form' }}</span>
                  <i class="bi" [ngClass]="isUploading ? 'bi-arrow-repeat ecb-corporate-spin' : 'bi-arrow-right'"></i>
                </button>
              </form>
            </div>

            <div class="ecb-corporate-security-note">
              <i class="bi bi-shield-lock"></i>
              <span>Your information is submitted securely and handled by the ECB Training team.</span>
            </div>
          </article>
        </div>
      </section>
    </div>
  </div>
</section>